.bi{flex-wrap:wrap;}